import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Field, Form } from "formik";
import { useNavigate } from "react-router-dom";
import AppStore from "../../../config/AppStore";
import {
  sendRequestGetMonthlyRevenueReportsAdmin,
} from "../../../view_logics/Reports/Reports";
import DatePickerField from "../../../components/common/DatePickerField";
import Select from "react-select";
import {
  sendRequestGetAdvertisersList,
  sendRequestGetAdvertiserOffers,
} from "../../../view_logics/AdvertiserOffers/AdvertiserOffer";

const PrepingReportFilter = ({ filters, onFilterChange }) => {
  const [reportsFilterLoading, setReportsFilterLoading] = useState(false);
  const [advertisersList, setAdvertisersList] = useState([]);
  const [advertiserOffers, setAdvertiserOffers] = useState([]);

  let store = AppStore.getAppStoreInstance();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAdvertisersData = async () => {
      try {
        const accessToken = store.getState().login.accessToken;
        const advertisersResult = await sendRequestGetAdvertisersList({ accessToken });
        if (advertisersResult) {
          setAdvertisersList(advertisersResult);
        }
      } catch (error) {
        console.error("Error fetching advertisers:", error);
      }
    };

    fetchAdvertisersData();
  }, []);

  useEffect(() => {
    const fetchAdvertiserOffersData = async () => {
      try {
        const inputObj = {
          accessToken: store.getState().login.accessToken,
          url: "report",
          history: navigate,
          data: [],
          dataHander: setAdvertiserOffers,
        };

        const offersResult = await sendRequestGetAdvertiserOffers(inputObj);

        if (offersResult) {
          setAdvertiserOffers(offersResult);
        }
      } catch (error) {
        console.error("Error fetching offers:", error);
      }
    };

    fetchAdvertiserOffersData();
  }, []);

  const validationSchema = Yup.object().shape({
    from: Yup.date()
      .required("From date is required")
      .max(Yup.ref("to"), "From date cannot be later than To date"),
    to: Yup.date()
      .required("To date is required")
      .min(Yup.ref("from"), "To date cannot be earlier than From date"),
  });

  const applyFilterHandler = async (values) => {
    setReportsFilterLoading(true);

    try {
      const response = await sendRequestGetMonthlyRevenueReportsAdmin({
        accessToken: store.getState().login.accessToken,
        data: values,
      });
      console.log("Filtered Data:", response);
    } catch (error) {
      console.error("Error fetching reports:", error);
    }

    setReportsFilterLoading(false);
  };

  return (
    <Formik
      initialValues={{
        email: filters.email ? filters.email :"",
        from: filters.from ? filters.from : new Date().toISOString(), // Default to today
        to: filters.to ? filters.to : new Date().toISOString(),   // Default to today
        advertiserId: filters.advertiserId ? filters.advertiserId :"",
        offerId: filters.offerId ? filters.offerId :"",
      }}
      validationSchema={validationSchema}
      // onSubmit={applyFilterHandler}
      enableReinitialize
      onSubmit={(values) => onFilterChange(values)}
    >
      {({ setFieldValue, values, errors, touched }) => (
        <Form>
          <div className="w-100 px-3 pt-3 d-flex gap-2 align-items-center">
            <div className="w-50">
              <label className="form-label" htmlFor="email">
                Email:
              </label>
              <Field
                type="email"
                id="email"
                name="email"
                className="form-control"
                placeholder="Enter Email"
                style={{ minHeight: 36 }}
              />
            </div>

            <div className="w-50">
              <label htmlFor="fromDate" className="form-label">From:</label>
              <DatePickerField
                id="fromDate"
                value={values.from}
                setValue={(date) => setFieldValue("from", date)}
              />
              {errors.from && touched.from && <div className="text-danger">{errors.from}</div>}
            </div>

            <div className="w-50">
              <label htmlFor="toDate" className="form-label">To:</label>
              <DatePickerField
                id="toDate"
                value={values.to}
                setValue={(date) => setFieldValue("to", date)}
              />
              {errors.to && touched.to && <div className="text-danger">{errors.to}</div>}
            </div>
          </div>

          <div className="w-100 px-3 pt-3 d-flex gap-2 align-items-center">
            <div className="w-50">
              <label htmlFor="advertiserId" className="form-label">Advertiser:</label>
              <Select
                id="advertiserId"
                name="advertiserId"
                options={[
                  { value: "", label: "Select Advertiser" },
                  ...advertisersList.map((adv) => ({
                    value: adv.id,
                    label: adv.name,
                  }))]}
                onChange={(selectedOption) => {
                  setFieldValue("advertiserId", selectedOption ? selectedOption.value : "");
                  setFieldValue("offerId", null);
                }}
                className="react-select-container"
                classNamePrefix="react-select"
                isClearable
              />
            </div>
            <div className="w-50">
              <label htmlFor="offerId" className="form-label">Advertiser Offer:</label>
              <Select
                id="offerId"
                name="offerId"
                value={
                  values.offerId
                    ? advertiserOffers
                        .filter((offer) => !values.advertiserId || offer.advertiser_id === values.advertiserId)
                        .map((offer) => ({
                          value: offer.id,
                          label: offer.name,
                        }))
                        .find((opt) => opt.value === values.offerId)
                    : null // 👈 very important
                }
                options={[
                  { value: "", label: "Select Advertiser Offer" },
                  ...advertiserOffers
                    .filter((offer) => !values.advertiserId || offer.advertiser_id === values.advertiserId) // inline filter
                    .map((offer) => ({
                      value: offer.id,
                      label: offer.name,
                    }))
                ]}
                /* options={advertiserOffers.map((offer) => ({
                  value: offer.id,
                  label: offer.name,
                }))} */
                onChange={(selectedOption) => setFieldValue("offerId", selectedOption ? selectedOption.value : "")}
                className="react-select-container"
                classNamePrefix="react-select"
                isClearable
              />
            </div>

            <div className="w-50 d-flex gap-1 mt-4">
              {reportsFilterLoading ? (
                <button className="btn btn-primary d-flex gap-2 align-items-center" type="button" disabled>
                  <span className="spinner-border spinner-border-sm" role="status" ></span>
                  Applying...
                </button>
              ) : (
                <button type="submit" className="btn btn-primary">Apply</button>
              )}
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default PrepingReportFilter;
